angular
	.module('app', ['appIke.config', 'ui.router', 'ui.select', 'LocalForageModule', 'ngMap', 'ngCookies', 'angular-jwt', 'toastr', 'ngAnimate']);
